import PropTypes from 'prop-types';

import {
  Grid,
  Typography,
  FormControl,
  Tooltip,
  OutlinedInput,
  InputAdornment,
  FormHelperText,
  Stack
} from '@material-ui/core';
import { useEffect, useState } from 'react';
import { useTheme } from '@material-ui/core/styles';
// import refreshIcon from '@iconify/icons-tabler/refresh';
import roundWarning from '@iconify/icons-ic/round-warning';
import { Icon } from '@iconify/react';
// import arrowRightLeft from '@iconify/icons-lucide/arrow-right-left';
import { boxStyling } from 'src/utils/styles';
import InfoRoundedIcon from '@material-ui/icons/InfoRounded';
const AmountDetails = ({ usd, egp, rate, onChangeAmount, viewOnly, percentage_covered }) => {
  const [initialEGP, setInitialEGP] = useState(null);
  const [initialRate, setInitialRate] = useState(null);
  const theme = useTheme();
  useEffect(() => {
    if (initialEGP === null && !isNaN(egp)) {
      setInitialEGP(egp);
    }
    if (initialRate === null && !isNaN(rate)) {
      setInitialRate(rate);
    }
  }, [egp, rate]);

  return (
    <div style={{ ...boxStyling, padding: '15px' }}>
      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        marginBottom={theme.spacing(2)}
      >
        <Typography variant="h4">Request Amount</Typography>
        <Tooltip
          title={`
              This is ${percentage_covered}% of the total amount requested.
            `}
          arrow
          placement="top"
        >
          <InfoRoundedIcon fontSize="small" color={theme.palette.grey[500]} />
        </Tooltip>
      </Stack>
      <Grid
        alignItems={'center'}
        container
        direction={'row'}
        justifyContent={'space-between'}
        spacing={2}
      >
        {/*<Grid item xs={12} md={4}>*/}
        {/*  <FormControl*/}
        {/*    fullWidth*/}
        {/*    style={{*/}
        {/*      margin: theme.spacing(1)*/}
        {/*    }}*/}
        {/*  >*/}
        {/*    {Number(usd) < 0 && (*/}
        {/*      <Typography*/}
        {/*        style={{*/}
        {/*          position: 'absolute',*/}
        {/*          top: '-20px'*/}
        {/*        }}*/}
        {/*        color="error"*/}
        {/*      >*/}
        {/*        This value must be positive*/}
        {/*      </Typography>*/}
        {/*    )}*/}
        {/*    <OutlinedInput*/}
        {/*      id="outlined-adornment-usd"*/}
        {/*      startAdornment={<InputAdornment position="start">$</InputAdornment>}*/}
        {/*      aria-describedby="outlined-usd-helper-text"*/}
        {/*      inputProps={{*/}
        {/*        'aria-label': 'amount_usd'*/}
        {/*      }}*/}
        {/*      onChange={(e) => onChangeAmount('USD', e.target.value)}*/}
        {/*      value={usd}*/}
        {/*      type="number"*/}
        {/*      readOnly={viewOnly}*/}
        {/*      disabled={viewOnly}*/}
        {/*      error={Number(usd) < 0}*/}
        {/*      onWheel={(e) => e.target.blur()}*/}
        {/*    />*/}
        {/*    <FormHelperText id="standard-usd-helper-text">Amount To Be Paid (USD)</FormHelperText>*/}
        {/*  </FormControl>*/}
        {/*</Grid>*/}

        {/*<Grid*/}
        {/*  item*/}
        {/*  xs={0}*/}
        {/*  md={1}*/}
        {/*  container*/}
        {/*  alignItems={'center'}*/}
        {/*  justifyContent={'center'}*/}
        {/*  height={'100%'}*/}
        {/*  fullWidth*/}
        {/*>*/}
        {/*  <Icon*/}
        {/*    icon={arrowRightLeft}*/}
        {/*    color={'textSecondary'}*/}
        {/*    fontSize={'1rem'}*/}
        {/*    style={{*/}
        {/*      marginBottom: theme.spacing(2),*/}
        {/*      width: '100%'*/}
        {/*    }}*/}
        {/*  />*/}
        {/*</Grid>*/}
        <Grid item xs={12} md={4}>
          <FormControl
            fullWidth
            className={{ margin: theme.spacing(1), marginTop: theme.spacing(3) }}
          >
            {Number(egp) < 0 && (
              <Typography
                style={{
                  position: 'absolute',
                  top: '-20px'
                }}
                color="error"
              >
                This value must be positive
              </Typography>
            )}
            <OutlinedInput
              onWheel={(e) => e.target.blur()}
              id="outlined-adornment-egp"
              startAdornment={<InputAdornment position="start">EGP</InputAdornment>}
              endAdornment={
                egp > initialEGP && (
                  <InputAdornment position="end">
                    <Tooltip
                      title={
                        egp < 0
                          ? 'The value must be positive'
                          : 'This value is more than the request amount'
                      }
                      arrow
                    >
                      <Icon
                        icon={roundWarning}
                        fontSize={theme.spacing(2.5)}
                        style={{
                          cursor: 'pointer',
                          color: theme.palette.error.dark
                        }}
                      />
                    </Tooltip>
                  </InputAdornment>
                )
              }
              readOnly={viewOnly}
              disabled={viewOnly}
              aria-describedby="outlined-egp-helper-text"
              inputProps={{
                'aria-label': 'amount_egp'
              }}
              onChange={(e) => onChangeAmount('EGP', e.target.value)}
              value={egp}
              type="number"
              error={Number(egp) > Number(initialEGP) || Number(egp) < 0 || Number(usd) < 0}
            />
            <FormHelperText id="standard-egp-helper-text">Amount To Be Paid (EGP)</FormHelperText>
          </FormControl>
        </Grid>

        {/*<Grid item xs={12} md={3}>*/}
        {/*  <FormControl*/}
        {/*    fullWidth*/}
        {/*    className={{ margin: theme.spacing(1), marginTop: theme.spacing(3) }}*/}
        {/*  >*/}
        {/*    <OutlinedInput*/}
        {/*      id="outlined-adornment-rate"*/}
        {/*      startAdornment={*/}
        {/*        <InputAdornment position="start">*/}
        {/*          <Icon icon={refreshIcon} />*/}
        {/*        </InputAdornment>*/}
        {/*      }*/}
        {/*      onWheel={(e) => e.target.blur()}*/}
        {/*      aria-describedby="outlined-rate-helper-text"*/}
        {/*      inputProps={{*/}
        {/*        'aria-label': 'amount_rate'*/}
        {/*      }}*/}
        {/*      onChange={(e) => onChangeAmount('rate', e.target.value)}*/}
        {/*      value={rate}*/}
        {/*      type="number"*/}
        {/*      readOnly={viewOnly}*/}
        {/*      disabled={viewOnly}*/}
        {/*    />*/}
        {/*    <FormHelperText id="standard-rate-helper-text">USD to EGP Rate</FormHelperText>*/}
        {/*  </FormControl>*/}
        {/*</Grid>*/}
      </Grid>
    </div>
  );
};

AmountDetails.propTypes = {
  usd: PropTypes.number,
  egp: PropTypes.number,
  rate: PropTypes.number,
  onChangeAmount: PropTypes.func
};

export default AmountDetails;
